"use client";

import { useSyncExternalStore } from "react";

const subscribe = () => () => {};
const FALLBACK_YEAR = 2026;

/**
 * Aktuelles Jahr. Beim Prerender wird ein fester Wert ausgegeben, im Browser
 * das echte Datum (Cache Components erlaubt kein `new Date()` beim Prerender).
 */
export function Year() {
  const year = useSyncExternalStore(
    subscribe,
    () => new Date().getFullYear(),
    () => FALLBACK_YEAR,
  );
  return <>{year}</>;
}
